/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getAssetHisLocationByAssetNo } from "services/asset";
import SnackbarUtils from "utils/SnackbarUtils";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  tableHeader: {
    backgroundColor: theme.palette.grey[100],
    fontWeight: "bold",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4),
  },
  emptyContainer: {
    padding: theme.spacing(4),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

const ChangeLogDialog = ({ open, onClose, assetId, assetNo }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);

  const fetchLogs = async () => {
    if (!assetId) return;
    setLoading(true);
    try {
      // Standard astNo fallback if not provided
      const finalAstNo = assetNo || "01"; 
      const response = await getAssetHisLocationByAssetNo(assetId, finalAstNo);
      if (response && response.Data) {
        setLogs(response.Data);
      } else if (Array.isArray(response)) {
        setLogs(response);
      } else {
        setLogs([]);
      }
    } catch (e) {
      SnackbarUtils.error("Failed to load asset location history logs");
      setLogs([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (open && assetId) {
      fetchLogs();
    }
  }, [open, assetId, assetNo]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle className={classes.dialogTitle}>Asset Modification History (Change Log)</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box className={classes.loadingContainer}>
            <CircularProgress />
          </Box>
        ) : logs.length === 0 ? (
          <Box className={classes.emptyContainer}>
            <Typography variant="body1">No modification or location logs recorded for this asset.</Typography>
          </Box>
        ) : (
          <TableContainer component={Paper} elevation={0}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeader}>Date/Time</TableCell>
                  <TableCell className={classes.tableHeader}>User</TableCell>
                  <TableCell className={classes.tableHeader}>Activity / Field</TableCell>
                  <TableCell className={classes.tableHeader}>Previous Value</TableCell>
                  <TableCell className={classes.tableHeader}>New Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logs.map((log, index) => {
                  return (
                    <TableRow key={index} hover>
                      <TableCell>
                        {log.ActionDate || log.CreatedDate || log.LastModified || "-"}
                      </TableCell>
                      <TableCell>{log.CreatedBy || log.UserName || "-"}</TableCell>
                      <TableCell>{log.Action || log.FieldName || "Location Update"}</TableCell>
                      <TableCell>{log.OldValue || log.PrevLocationCode || "-"}</TableCell>
                      <TableCell style={{ fontWeight: "bold", color: "#2196f3" }}>
                        {log.NewValue || log.NewLocationCode || "-"}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeLogDialog;
